function isInViewport(el) {
  const rect = el?.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

class VariantPair extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(event) {
    event?.stopPropagation();

    const pairAddtoCartWrap = document.querySelector("pair-add-to-cart");
    if (!pairAddtoCartWrap) {
      console.warn("[VariantChange] pair-add-to-cart not found");
      return;
    }
  
    const pairAddtoCart = pairAddtoCartWrap.querySelector(".product-form__submit");
    const pairTotalPrices = document.querySelectorAll(".pair-total-price");
    const pairTotalComparePrices = document.querySelectorAll(".pair-compare-total-price");
    const savingPercents = document.querySelectorAll(".savings-percent");
    const allQtyInputs = this.querySelectorAll('[name="quantity"]');
    const checkedAddons = this.querySelectorAll(".js-addon-checkbox:checked");

    let totalQty = 0;
    let totalPrice = 0;
    let totalComparePrice = 0;
    let allHaveCompare = true;

    allQtyInputs.forEach((input) => {
      // Rows belonging to a non-selected color are hidden, not removed.
      if (input.closest(".pairs-selector__row")?.hidden) return;

      const qty = parseInt(input.value) || 0;
      const price = parseInt(input.getAttribute("data-price")) || 0;
      const comparePrice = parseInt(input.getAttribute("data-compare-price")) || 0;

      totalQty += qty;
      totalPrice += price * qty;

      if (comparePrice > 0) {
        totalComparePrice += comparePrice * qty;
      } else {
        allHaveCompare = false;
      }
    });

    // Add-ons don't count toward totalQty (a pair still has to be picked to
    // enable Add to Cart), but their price is folded into the running total.
    checkedAddons.forEach((checkbox) => {
      totalPrice += parseInt(checkbox.dataset.price) || 0;
    });

    // Enable/disable Add to Cart button
    if (pairAddtoCart) {
      pairAddtoCart.toggleAttribute("disabled", totalQty === 0);
    }
  
    // Update total price. With nothing selected yet, fall back to showing
    // the lowest variant price (prefixed "From" when the price varies)
    // rather than a static $0.00.
    pairTotalPrices.forEach((el) => {
      if (totalQty === 0) {
        const wrap = el.closest(".pairs-selector__total");
        const minPrice = parseInt(wrap?.dataset.minPrice) || 0;
        const priceVaries = wrap?.dataset.priceVaries === "true";
        const formattedMinPrice = formatMoney(minPrice, window.shopSettings.moneyFormat);
        el.innerText = priceVaries ? `From ${formattedMinPrice}` : formattedMinPrice;
      } else {
        el.innerText = formatMoney(totalPrice, window.shopSettings.moneyFormat);
      }
    });
  
    // Update compare price and savings if all have compare prices
    if (allHaveCompare && totalComparePrice > totalPrice) {
      const savings = (((totalComparePrice - totalPrice) * 100) / totalComparePrice).toFixed(0);
  
      pairTotalComparePrices.forEach((el) => {
        el.innerText = formatMoney(totalComparePrice, window.shopSettings.moneyFormat);
      });
  
      savingPercents.forEach((el) => {
        el.innerText = `Save ${savings}%`;
      });
    } else {
      // If not all have compare price, hide compare prices and savings
      pairTotalComparePrices.forEach((el) => el.innerText = "");
      savingPercents.forEach((el) => el.innerText = "");
    }
  
    console.log(
      `[VariantChange] totalQty: ${totalQty}, totalPrice: ${totalPrice}, totalCompare: ${totalComparePrice}, allHaveCompare: ${allHaveCompare}`
    );
  }
}

customElements.define("variant-pair", VariantPair);

class PairAddToCart extends HTMLElement {
  constructor() {
    super();

    this.submitButton = this.querySelector(".product-form__submit");
    this.submitButton.addEventListener(
      "click",
      this.onSubmitHandler.bind(this)
    );
    this.inputs = document.querySelectorAll(".js-pair-qty-input");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    document.addEventListener("scroll", this.handleCTAbutton.bind(this), {
      passive: true,
    });
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");

    let items = [];

    this.inputs.forEach((el) => {
      // Never cart a row the customer can't see (a color they navigated away from).
      if (el.closest(".pairs-selector__row")?.hidden) return;

      if (el.value > 0) {
        let item = {
          id: el.dataset.id,
          quantity: el.value,
        };
        items.push(item);
      }
    });

    // The add-on checkboxes are a sibling of <pair-add-to-cart>, both inside
    // <variant-pair>, not a descendant of this element.
    this.closest("variant-pair")
      ?.querySelectorAll(".js-addon-checkbox:checked")
      .forEach((checkbox) => {
        items.push({
          id: checkbox.dataset.variantId,
          quantity: 1,
        });
      });

    let res;

    if (items.length > 0) {
      const data = {
        items,
        sections: ["cart-drawer", "cart-icon-bubble"],
      };

      res = fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");

          $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function (data) {
              if (data) {
                console.log(data);
                var obj = data.items;
                var gtot = 0;
                $.each(obj, function (key, value) {
                  gtot = value.grams * value.quantity + gtot;
                });
                var weight = Math.round(gtot / 453.6),
                  percentage = Math.round(
                    (Math.round(gtot / 453.6) / 1500) * 100
                  ),
                  modulo = ((weight % 250) - 250) * -1,
                  pt = percentage + "%";
                
                // Cap percentage at 100%
                if (percentage > 100) {
                  pt = "100%";
                }
                
                console.log(pt);
                $(".progress-value").each(function () {
                  $(this).removeClass("animated").css("width", pt);
                  // Update background color for free shipping
                  if (weight >= 1500) {
                    $(this).css('background-color', '#007D48 !important');
                  } else {
                    $(this).css('background-color', '');
                  }
                });
                $(".addmore .weight").each(function () {
                  $(this).text(modulo);
                });
              }
              /// estimator
              if ($("#shipping-estimates .totals-est").length > 0) {
                $.ajax({
                  type: "POST",
                  url: "//hook.us1.make.celonis.com/b10fd8ltisl5fzxo7728u6tst301how6",
                  data: data,
                  dataType: "json",
                  success: function (data) {
                    console.log("shipping estimate", data);
                    const {
                      service_name,
                      max_delivery_date,
                      min_delivery_date,
                      total_price,
                    } = data.rates[0];
                    console.log(data.rates[0].total_price);
                    var mny = data.rates[0].total_price,
                      mnytot = data.rates[0].original_price;
                    $("#shipping-estimates .totals-est").text(
                      "$" + parseInt(mny) / 100
                    );
                    $("#shipping-estimates2 .totals-est").text(
                      "$" + parseInt(mny) / 100
                    );
                    $("#shipping-estimates .totals-esttot").text(mnytot);
                    $("#shipping-estimates2 .totals-esttot").text(mnytot);
                  },
                });
              }
            },
          });

          if (this.cart) {
            if (this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.cart.renderContents(response);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

    return res;
  }

  handleCTAbutton() {
    const cartAvailable = isInViewport(this.submitButton);
    const floatingCTA = document.querySelector(".js-pdp-floating-cta");
    const addToCart = this.querySelector(".product-form__submit");
    const floatingCTAHTML = `<div class="product-form-floating-cta js-pdp-floating-cta">
      <button id="selectWeightBtn" class="select-weight-button floating-add-to-cart-btn button button--full-width button--secondary"> 
        Select Weight
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6" style="width: 1.8rem; margin-left: 0.5rem;">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
          </path>
        </svg>
      </button>
    </div>`;

    if (window.innerWidth < 768) {
      if (cartAvailable) {
        if (floatingCTA) {
          floatingCTA.remove();
        }
      } else {
        if (floatingCTA) {
          floatingCTA.addEventListener("click", function () {
            addToCart.click();
            if (addToCart.hasAttribute("disabled")) {
              document
                .querySelector(".sidebar__inner")
                .scrollIntoView({ behavior: "smooth" });
            }
          });
        } else {
          this.insertAdjacentHTML("beforeend", floatingCTAHTML);
        }
      }
    }
  }
}

customElements.define("pair-add-to-cart", PairAddToCart);

// "N weights · X – Y · Z currently sold out" in the dumbbells/kettlebells popup
// header. Derived from the rendered rows, so it has to run after their `hidden`
// state has been updated for the newly selected color.
function updatePairsPopupCounts(pairsSelector) {
  const popup = pairsSelector.querySelector("[data-pairs-popup]");
  if (!popup) return;

  const visibleRows = pairsSelector.querySelectorAll(
    ".pairs-selector__row:not([hidden])",
  );

  let soldOutCount = 0;
  visibleRows.forEach((row) => {
    if (row.classList.contains("pairs-selector__row--unavailable"))
      soldOutCount += 1;
  });

  const soldOutValue = popup.querySelector("[data-pairs-sold-out]");
  if (soldOutValue) soldOutValue.textContent = soldOutCount;

  const soldOutWrap = popup.querySelector("[data-pairs-sold-out-wrap]");
  if (soldOutWrap) soldOutWrap.hidden = soldOutCount === 0;

  const totalValue = popup.querySelector("[data-pairs-total]");
  if (totalValue) totalValue.textContent = visibleRows.length;
}

document.addEventListener("change", (event) => {
  if (event.target.closest(".pairs-selector")) return;

  const variantSelects = event.target.closest("variant-selects");
  if (!variantSelects) return;

  const pairsSelector = variantSelects.querySelector(".pairs-selector");
  if (!pairsSelector) return;

  // The Color fieldset is the only other, visible picker in this component
  // (the Size/Weight fieldset the pairs list stays in sync with is hidden).
  const colorFieldset = variantSelects.querySelector("fieldset:not([hidden])");
  const selectedColor = colorFieldset?.querySelector("input:checked")?.value;
  if (selectedColor === undefined) return;

  // Quantities on the color being left are kept, not cleared, so switching back
  // restores what the customer had picked. They can't leak into the total or the
  // cart because both readers skip rows that are hidden.
  pairsSelector.querySelectorAll(".pairs-selector__row").forEach((row) => {
    row.hidden = row.dataset.pairsColor !== selectedColor;
  });

  pairsSelector
    .querySelectorAll(".pairs-selector__weight-sets[data-pairs-color]")
    .forEach((group) => {
      group.hidden = group.dataset.pairsColor !== selectedColor;
    });

  updatePairsPopupCounts(pairsSelector);

  // <variant-pair> only recomputes off its own 'change' events, and the color
  // swatch lives outside it — without this the totals and the Add to Cart state
  // keep showing the previous color's numbers.
  pairsSelector.dispatchEvent(new Event("change", { bubbles: true }));
});

const footerr = document.querySelector("footer");
const footer_observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      if (document.querySelector(".floating-add-to-cart-btn"))
        document.querySelector(".floating-add-to-cart-btn").style.display =
          "none";
    } else {
      if (document.querySelector(".floating-add-to-cart-btn"))
        document.querySelector(".floating-add-to-cart-btn").style.display =
          "block";
    }
  });
});
footer_observer.observe(footerr);
